import { InputAdornment, Typography } from "@mui/material";

interface LockedDomainAdornmentProps {
  domain: string;
  testId?: string;
}

export function LockedDomainAdornment({
  domain,
  testId,
}: LockedDomainAdornmentProps) {
  return (
    <InputAdornment position="end">
      <Typography
        variant="body2"
        data-testid={testId}
        sx={{
          color: "text.secondary",
          whiteSpace: "nowrap",
          userSelect: "none",
        }}
      >
        @{domain}
      </Typography>
    </InputAdornment>
  );
}
